export default "__VITE_ASSET__Ccgjfsnq__"